import { alpha, createTheme, darken, lighten } from "@mui/material/styles";
import { zabbixSeverty, appBarEasyMaps, colorsAlerts } from "../colors";
import { themeLight, themeDark } from "./customTheme";

const easyMapsTheme = (colorMode) =>
  createTheme({
    ...(themeDark() && themeLight()
      ? colorMode
        ? { palette: { mode: !colorMode ? "light" : "dark", ...themeDark() } }
        : { palette: { mode: !colorMode ? "light" : "dark", ...themeLight() } }
      : {
          palette: {
            mode: !colorMode ? "light" : "dark",
            primary: {
              main: !colorMode ? "#ec4b60" : "#e83750",
            },
            secondary: {
              main: colorMode ? "#5B2E87" : "#A77AD2",
            },
            drawer: {
              main: !colorMode ? "#5B2E87" : "#5B2E87",
              text: !colorMode ? "#E8E6E3" : "#ffffff",
              chat: !colorMode ? "#fff " : "#000000",
            },
            background: {
              hover: !colorMode ? "#f7f6f6ff" : "#252525",
              paper: !colorMode ? "#fff " : "#1E1E1E",
              default: !colorMode ? "#eeeeeeff" : "#141617", //EEF2F6
              sideBar: !colorMode ? "#eeeeeeff" : "#141617",
              paperLinkedMaps: !colorMode ? "#e4e4e4" : "#292929",
              paperSelectedMaps: !colorMode ? "#ffffff" : "#202020ff",
              paperNotification: !colorMode ? "#f1eeee" : "#282a2b",
              cardStatus: !colorMode ? "#EBEBEB" : "#242424",
              tab: !colorMode ? "#dcdcdc" : "#292929",
            },
            text: {
              primary: colorMode ? "#ffffff" : "#252525",
              invert: !colorMode ? "#ffffff" : "#252525",
              shadow: colorMode
                ? darken("#fff", 0.35)
                : lighten("#252525", 0.2),
              disabled: colorMode ? "#969696" : "#676767",
            },
            chip: {
              pending: !colorMode ? "#E83750" : "#df1130",
              inProgress: !colorMode ? "#ED6C02" : "#d46204",
              completed: !colorMode ? "#2E7D32" : "#387F4D",
              waitingReview: !colorMode ? "#0288D1" : "#077CB1",
              waitingReturn: !colorMode ? "#5B2E87" : "#502876",
              arquive: !colorMode ? "#777777" : "#424242",
            },
            color: {
              icons: colorMode ? "#e6e6e6 " : "#4e4e4e",
              iconsDisable: colorMode ? "#575757ff" : "#afafaf",
              bgIcon: !colorMode ? "#b9b9b9 " : "#797676",
              text: colorMode ? "#fff " : "#313131",
              appBarBorder: colorMode ? "#303030" : "#d4d4d4",
              buttonConfirm: colorMode ? "#fff " : "#000000",
              menuItem: colorMode ? "#431D23" : "#F2DBDF",
              zabbixSeverty: zabbixSeverty(colorMode),
              appBarEasyMaps: appBarEasyMaps(colorMode),
              alerts: colorsAlerts(colorMode),
              textEasyMapsInvert: !colorMode ? "#fff " : "#252525",
              textEasyMaps: colorMode ? "#fff " : "#252525",
              textDisabled: colorMode ? "#969696" : "#676767",
              status: {
                up: !colorMode ? "#387F4D" : "#387F4D",
                down: !colorMode ? "#EE1127" : "#EE1127",
              },
              lineDefault: "#9a7ca0ff",
            },
            layers: {
              trafego: colorMode ? "#cb3c51" : "#ca465a",
              potencia: colorMode ? "#3c93b8" : "#267DA3",
              ftth: colorMode ? "#fff " : "#252525",
            },
            linearCarousel: {
              percent0: colorMode ? "#1e1e1eff" : "#ffffffff",
              percent50: colorMode ? "#1e1e1e85" : "#ffffff85",
              percent100: colorMode ? "#1e1e1e28" : "#ffffff28",
            },
            enlaces: {
              offline: { main: colorMode ? "#babdb7a1" : "#7c7b7bc2" },
              p0: { main: "#55b3a8" },
              p1: { main: "#56A64B" },
              p5: { main: "#37872D" },
              p15: { main: "#F2CC0C" },
              p20: { main: "#fcc71c" },
              p25: { main: "#E0B400" },
              p50: { main: "#FF780A" },
              p70: { main: "#FA6400" },
              p80: { main: "#da442a" },
              p90: { main: "#be0000" },
            },
          },
        }),
    breakpoints: {
      values: {
        xs: 0,
        xsm: 400,
        sm: 600,
        smd: 700,
        md: 900,
        mdl: 1000,
        lg: 1200,
        xl: 1536,
        fh: 1920,
        qhd: 2560,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ".custom-ruler-tooltip.leaflet-tooltip": {
            background: "transparent !important",
            border: "none !important",
            boxShadow: "none !important",
            padding: "0 !important",
            margin: "0 !important",
          },
          ".custom-ruler-tooltip.leaflet-tooltip:before": {
            display: "none !important",
          },
          ".custom-ruler-tooltip.leaflet-tooltip:after": {
            display: "none !important",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: ({ theme }) => ({
            "& .MuiInputLabel-root": {
              fontSize: "1rem", // Tamanho do texto do label
            },
            "& .MuiInputBase-input": {
              fontSize: "1rem", // Tamanho do texto do placeholder
              display: "flex",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "transparent",
              },
              boxShadow: "0px 0px 3px  #0000001a",
              backgroundColor: theme.palette.background.paperSelectedMaps,

              "&.Mui-focused": {
                backgroundColor: "none",
                "& fieldset": {
                  border: `1px solid  ${theme.palette.primary.main}`,
                },
                "&:hover": {
                  "& fieldset": {
                    border: `1px solid  ${theme.palette.primary.main}`,
                  },
                },
              },

              "&:hover": {
                backgroundColor: theme.palette.background.hover,
                "& fieldset": {
                  borderColor: "transparent",
                },
              },
              "&.Mui-disabled": {
                backgroundColor: alpha(
                  theme.palette.background.paperLinkedMaps,
                  0.2,
                ),
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover": {
                  "& fieldset": {
                    borderColor: "none",
                  },
                },
              },
            },
          }),
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundImage: "none",
            backgroundColor: theme.palette.background.paper,
          }),
        },
      },
      MuiButton: {
        styleOverrides: {
          root: ({ theme }) => ({
            containedPrimary: colorMode && {
              backgroundColor: theme.palette.primary.main,
            },
          }),
        },
      },
      MuiChip: {
        styleOverrides: {
          containedPrimary: true && { backgroundColor: "#5B2E87" },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: ({ theme }) => ({
            colorPrimary: {
              backgroundColor: theme.palette.primary.main,
            },
          }),
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "6px",
            borderWidth: "2px",
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            borderRadius: "6px",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            padding: "20px",
            borderRadius: "10px",
            display: "flex",
            gap: "8px",
            flexDirection: "column",
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: ({ theme }) => ({
            "&.MuiTypography-root": {
              color: theme.palette.primary.main,
              padding: 0,
            },
          }),
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            display: "flex",
            gap: "8px",
            flexDirection: "column",
            padding: 1,
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            padding: 0,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.color.text,
          }),
        },
        variants: [
          {
            props: { variant: "small" },
            style: {
              fontSize: "0.75rem",
            },
          },
          {
            props: { variant: "default" },
            style: {
              fontSize: "0.875rem",
            },
          },
          {
            props: { variant: "textFieldTitle" },
            style: {
              fontSize: "0.875rem",
              fontWeight: 600,
            },
          },
        ],
      },
    },
    global: `
      .leaflet-layer,
      .leaflet-control-zoom-in,
      .leaflet-control-zoom-out,
      .leaflet-control-attribution {
        filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%);
      }
    `,
  });

export default easyMapsTheme;
